module.exports = __webpack_public_path__ + "img/bontje_logo.4a3169ef.png";